import axios from "axios";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}

export const managementAPI = {
  getAllBlackList: (thenCallback) => {
    //`${config.baseUrl}${config.getRequestsUsers}`
    console.log(process.env.REACT_APP_BASE_URL);
    axios
      .get(
        `${apiUrl}${process.env.REACT_APP_GET_ALL_BLACKLIST_ENDPOINT}${process.env.REACT_APP_GET_ALL_BLACKLIST_CODE}`,
        { timeout: 60000 }
      )
      .then((res) => {
        thenCallback(res);
      })
      .catch((err) => {
        if (err.code === "ECONNABORTED") {
          // timeout
          console.log("Timeout");
          thenCallback(err);
        }
        if (err.status === 401) {
          window.sessionStorage.removeItem("user");
          window.sessionStorage.clear();
          window.location.href = "/Unauthorized";
        }
        if (err.response && err.response.data && err.response.data.length > 0) {
          thenCallback(err.response.data);
        }
        console.log(err);
        thenCallback(err);
      });
  },

  deleteBlackList: async (blackList) => {
    try {
      const res = await axios.post(
        `${apiUrl}${process.env.REACT_APP_DELETE_BLACKLIST_ENDPOINT}${process.env.REACT_APP_DELETE_BLACKLIST_CODE}`,
        blackList,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 60000,
        }
      );
      return res;
    } catch (error) {
      if (error.response.status === 401) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },

  updateBlackList: async (blackList) => {
    try {
      const res = await axios.post(
        `${apiUrl}${process.env.REACT_APP_UPDATE_BLACKLIST_ENDPOINT}${process.env.REACT_APP_UPDATE_BLACKLIST_CODE}`,
        blackList,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 60000,
        }
      );
      console.log(res);
      return res;
    } catch (error) {
      if (error.response.status === 401) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },
  addBlackList: async (blackList) => {
    try {
      const res = await axios.post(
        `${apiUrl}${process.env.REACT_APP_ADD_BLACKLIST_ENDPOINT}${process.env.REACT_APP_ADD_BLACKLIST_CODE}`,
        blackList,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 60000,
        }
      );
      console.log(res);
      return res;
    } catch (error) {
      if (error.response.status === 401) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },

  exportExcel: async (type) => {
    try {
      return axios.get(
        `${apiUrl}${process.env.REACT_APP_EXPORT_VALID_BLACKLIST_ENDPOINT}${process.env.REACT_APP_EXPORT_VALID_BLACKLIST_CODE}`,
        {
          headers: { "Content-Type": "application/json" },
          params: {
            type: type,
          },
          responseType: "blob",
          timeout: 60000,
        }
      );
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        // timeout
        console.log("Timeout");
        throw error;
      }
      if (error.response.status === 401) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },
};
